import { ChangeDetectionStrategy, Component, DestroyRef, computed, effect, inject, input, output } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Show } from '../../models/show';
import { PopupCloseComponent } from './popup-close.component';
import { formatShowDate } from '../../utils/show-date';
import { showTitle } from '../../utils/show-title';

@Component({
  selector: 'app-show-detail',
  imports: [PopupCloseComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './show-detail.component.html',
})
export class ShowDetailComponent {
  private readonly document = inject(DOCUMENT);

  show = input<Show | null>(null);
  closed = output();

  readonly when = computed(() => {
    const show = this.show();
    return show ? formatShowDate(show.datetime) : '';
  });

  readonly title = computed(() => {
    const show = this.show();
    return show ? showTitle(show) : '';
  });

  readonly details = computed(() => this.show()?.description ?? '');

  constructor() {
    effect(() => {
      this.document.body.style.overflow = this.show() ? 'hidden' : '';
    });
    inject(DestroyRef).onDestroy(() => (this.document.body.style.overflow = ''));
  }

  close() { this.closed.emit(); }
}

